import baseURL from "../Api/baseURL";

const useUpdateData = async (url, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const res = await baseURL.put(url, params, config);
  return res.data;
};
const useUpdateDataWithImage = async (url, params) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const res = await baseURL.put(url, params, config);
  return res;
};

// updateDataWithImageWithProgressBar
const uploadImageWithProgressBar = async (
  type,
  url,
  params,
  onUploadProgress
) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    onUploadProgress,
  };

  if (type === "post") {
    const res = await baseURL.post(url, params, config);
    return res;
  }

  if(type==="put"){
      const res = await baseURL.put(url, params, config);
      return res;
  }

};

export {
  useUpdateData,
  useUpdateDataWithImage,
  uploadImageWithProgressBar,
};
